export const config = {
    environment: 'production',
    api: {
        host: "https://api.rapidevcharge.com"
    },
    weblinks: {
        about: "https://api.rapidevcharge.com/common/static/images/about.html",
        aboutCPO: "https://api.rapidevcharge.com/common/static/images/aboutCPO.html",
        support: "https://api.rapidevcharge.com/common/static/images/help.html",
        supportCPO: "https://api.rapidevcharge.com/common/static/images/helpCPO.html",
        helpVideo: "https://api.rapidevcharge.com/common/static/images/helpVideo.html"
    },
    payment: {
        gateway: {
            endpoint: "https://eazypay.icicibank.com/EazyPG"
        },
        merchant: {
            id: "100011",
            referenceNo: "8001",
            subMerchant: {
                id: "1234"
            }
        },
        callbackUrl: "http://abc.com/cbc/action.aspx"
    }
}